import { dataJobRunTrackerConstants } from "../_constants";

export function jobRunTrackerList(state = {}, action) {
  switch (action.type) {
    case dataJobRunTrackerConstants.GET_ALL_JOB_RUN_TRACKER_REQUEST:
      return {
        loading: true,
      };
    case dataJobRunTrackerConstants.GET_ALL_JOB_RUN_TRACKER_SUCCESS:
      return {
        item: action.data,
      };
    case dataJobRunTrackerConstants.GET_ALL_JOB_RUN_TRACKER_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function jobRunTrackerById(state = {}, action) {
  switch (action.type) {
    case dataJobRunTrackerConstants.GET_JOB_RUN_TRACKER_BY_ID_REQUEST:
      return {
        loading: true,
      };
    case dataJobRunTrackerConstants.GET_JOB_RUN_TRACKER_BY_ID_SUCCESS:
      return {
        item: action.data,
      };
    case dataJobRunTrackerConstants.GET_JOB_RUN_TRACKER_BY_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function dataQualityChecks(state = {}, action) {
  switch (action.type) {
    case dataJobRunTrackerConstants.GET_DATA_QUALITY_CHECKS_REQUEST:
      return {
        loading: true,
      };
    case dataJobRunTrackerConstants.GET_DATA_QUALITY_CHECKS_SUCCESS:
      return {
        items: action.data,
      };
    case dataJobRunTrackerConstants.GET_DATA_QUALITY_CHECKS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function dataJobStageQualityFilter(state = {}, action) {
  switch (action.type) {
    case dataJobRunTrackerConstants.GET_DATA_QUALITY_CHECKS_FILTER_REQUEST:
      return {
        loading: true,
      };
    case dataJobRunTrackerConstants.GET_DATA_QUALITY_CHECKS_FILTER_SUCCESS:
      return {
        items: action.data,
      };
    case dataJobRunTrackerConstants.GET_DATA_QUALITY_CHECKS_FILTER_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
